var map = {
	"./abc.json": 94655,
	"./lessons.json": 41126,
	"./letter-data/0.json": 92843,
	"./letter-data/1.json": 91432,
	"./letter-data/2.json": 12549,
	"./letter-data/3.json": 38170,
	"./letter-data/4.json": 50647,
	"./letter-data/5.json": 1604,
	"./letter-data/6.json": 26993,
	"./letter-data/7.json": 35958,
	"./letter-data/8.json": 78547,
	"./letter-data/9.json": 38000,
	"./letter-data/A.json": 86168,
	"./letter-data/Aa.json": 22339,
	"./letter-data/B.json": 33557,
	"./letter-data/Bb.json": 48741,
	"./letter-data/C.json": 63114,
	"./letter-data/Cc.json": 78247,
	"./letter-data/D.json": 8935,
	"./letter-data/Dd.json": 73077,
	"./letter-data/DownCurve.json": 34544,
	"./letter-data/E.json": 76852,
	"./letter-data/Ee.json": 90923,
	"./letter-data/F.json": 9281,
	"./letter-data/Ff.json": 61933,
	"./letter-data/G.json": 65574,
	"./letter-data/Gg.json": 2999,
	"./letter-data/H.json": 80131,
	"./letter-data/Hh.json": 89485,
	"./letter-data/I.json": 38272,
	"./letter-data/Ii.json": 20739,
	"./letter-data/J.json": 69405,
	"./letter-data/Jj.json": 91605,
	"./letter-data/K.json": 85426,
	"./letter-data/Kk.json": 62423,
	"./letter-data/L.json": 57391,
	"./letter-data/LeftCurve.json": 91471,
	"./letter-data/Ll.json": 56165,
	"./letter-data/M.json": 65500,
	"./letter-data/Mm.json": 5819,
	"./letter-data/N.json": 7401,
	"./letter-data/Nn.json": 35213,
	"./letter-data/O.json": 6318,
	"./letter-data/Oo.json": 31175,
	"./letter-data/P.json": 81611,
	"./letter-data/Pp.json": 62765,
	"./letter-data/Q.json": 37672,
	"./letter-data/Qq.json": 16963,
	"./letter-data/R.json": 13477,
	"./letter-data/RightCurve.json": 34896,
	"./letter-data/Rr.json": 40517,
	"./letter-data/S.json": 23770,
	"./letter-data/Slanting Line.json": 25557,
	"./letter-data/SleepingLine.json": 5538,
	"./letter-data/Ss.json": 48071,
	"./letter-data/StandingLine.json": 61155,
	"./letter-data/T.json": 73591,
	"./letter-data/Tt.json": 15381,
	"./letter-data/U.json": 4868,
	"./letter-data/UpCurve.json": 62959,
	"./letter-data/Uu.json": 9003,
	"./letter-data/V.json": 51217,
	"./letter-data/Vv.json": 50285,
	"./letter-data/W.json": 27222,
	"./letter-data/Ww.json": 17527,
	"./letter-data/X.json": 74867,
	"./letter-data/Xx.json": 77837,
	"./letter-data/Y.json": 62224,
	"./letter-data/Yy.json": 63843,
	"./letter-data/Z.json": 60269,
	"./letter-data/Zz.json": 9845,
	"./rhymes&stories.json": 18226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62009;